import { apiCall } from '../api/ServerApi';
import { API_URL_PATHS } from '../consts/ApiUrlPaths';
import { ICollection, ICollectionCreate, ICollectionUpdate } from '../interfaces/Collection';

import { logger } from './Logger';

const { COLLECTIONS_URL_PATH } = API_URL_PATHS;

export const apiGetCollections = async (): Promise<ICollection[]> => {
	try {
		return await apiCall('GET', COLLECTIONS_URL_PATH);
	} catch (error) {
		logger.error(`Failed to get collections with error: ${error}`);
		throw new Error(`Failed to get collections. Error ${error}`);
	}
};

export const apiCreateCollection = async (collection: ICollectionCreate): Promise<ICollection> => {
	try {
		return await apiCall('POST', COLLECTIONS_URL_PATH, {
			data: collection
		});
	} catch (error) {
		logger.error('Failed to create a collection', error);
		throw new Error(`Failed to create a collection. Error ${error}`);
	}
};

export const apiEditCollection = async (collection: ICollectionUpdate): Promise<ICollection> => {
	try {
		return await apiCall('PUT', `${COLLECTIONS_URL_PATH}/${collection.id}`, {
			data: collection
		});
	} catch (error) {
		logger.error(`Failed to edit a collection with error: ${error}`);
		throw new Error(`Failed to edit a collection. Error ${error}`);
	}
};

export const apiRemoveCollection = async (collectionId: string): Promise<void> => {
	try {
		return await apiCall('DELETE', `${COLLECTIONS_URL_PATH}/${collectionId}`);
	} catch (error) {
		logger.error(`Failed to delete a collection with error: ${error}`);
		throw new Error(`Failed to delete a collection. Error ${error}`);
	}
};

export const addPropertyToCollectionById = async (
	collectionId: string,
	propertyId: string
): Promise<string> => {
	try {
		const body = { propertyIds: [propertyId] };
		return await apiCall('POST', `${COLLECTIONS_URL_PATH}/${collectionId}/properties`, {
			data: body
		});
	} catch (error) {
		logger.error(
			`Error in collection service in addPropertyToCollectionById with collectionId: ${collectionId}, propertyId: ${propertyId}, with error: ${error}`
		);
		throw new Error(
			`Error in collection service in addPropertyToCollectionById with collectionId: ${collectionId}, propertyId: ${propertyId}, with error: ${error}`
		);
	}
};

export const deletePropertyFromCollectionById = async (
	collectionId: string,
	propertyId: string
): Promise<string> => {
	try {
		return await apiCall(
			'DELETE',
			`${COLLECTIONS_URL_PATH}/${collectionId}/properties/${propertyId}`
		);
	} catch (error) {
		logger.error(
			`Error in collection service in deletePropertyFromCollectionById with collectionId: ${collectionId}, propertyId: ${propertyId}, with error: ${error}`
		);
		throw new Error(
			`Error in collection service in deletePropertyFromCollectionById with collectionId: ${collectionId}, propertyId: ${propertyId}, with error: ${error}`
		);
	}
};
